var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.67188 0.5 0 3.19531 0 6.5C0 9.82812 2.67188 12.5 6 12.5C9.30469 12.5 12 9.82812 12 6.5C12 3.19531 9.30469 0.5 6 0.5ZM6 9.875C5.57812 9.875 5.25 9.54688 5.25 9.125C5.25 8.70312 5.55469 8.375 6 8.375C6.39844 8.375 6.75 8.70312 6.75 9.125C6.75 9.54688 6.39844 9.875 6 9.875ZM7.61719 6.54688L6.5625 7.20312V7.25C6.5625 7.55469 6.30469 7.8125 6 7.8125C5.69531 7.8125 5.4375 7.55469 5.4375 7.25V6.875C5.4375 6.6875 5.53125 6.5 5.71875 6.38281L7.05469 5.58594C7.21875 5.49219 7.3125 5.32812 7.3125 5.14062C7.3125 4.85938 7.05469 4.625 6.77344 4.625H5.57812C5.27344 4.625 5.0625 4.85938 5.0625 5.14062C5.0625 5.44531 4.80469 5.70312 4.5 5.70312C4.19531 5.70312 3.9375 5.44531 3.9375 5.14062C3.9375 4.22656 4.66406 3.5 5.55469 3.5H6.75C7.71094 3.5 8.4375 4.22656 8.4375 5.14062C8.4375 5.70312 8.13281 6.24219 7.61719 6.54688Z",
    fill: "#CACED0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestion);
export default __webpack_public_path__ + "static/media/circle-question.3578190b.svg";
export { ForwardRef as ReactComponent };